import React from 'react';
import PopUp from '../../GeneralComponents/PopUp';

/*
This component renders a pop up that is being displayed when there is a unsaved page and user tries to go to another page
It asks the user to save - dont save or cancel.
*/
const ChangePagePopUpWindow = (props) => {
  const {
    editor,
    openAlert,
    setOpenAlert,
    savedPagesPerProject,
    setSavedPagesPerProject,
    indexPage,
    indexProject,
    setSelectedPage,
    setSelectedProject,
    selectedProject,
    selectedPage,
    savedPageClicked,
    setDisplaySpinner
  } = props;

  // This function is fired when user clicks dont save.It closes the pop up and go to another page without saving
  const handleDontSave = () => {
    editor.runCommand('enable-navigate-page');
    setDisplaySpinner(true);
    const tempSavedPagesPerProject = [...savedPagesPerProject];
    tempSavedPagesPerProject[selectedProject][selectedPage] = true;
    setSavedPagesPerProject(tempSavedPagesPerProject);

    setSelectedPage(indexPage);
    if (indexProject !== selectedProject) setSelectedProject(indexProject);
    setOpenAlert(false);
  };

  // This functions is firen when user clicks save. It closes the pop up, goes to other page and saves the previous page.
  const handleSave = () => {
    editor.runCommand('enable-navigate-page');
    savedPageClicked();
    setSelectedPage(indexPage);
    if (indexProject !== selectedProject) setSelectedProject(indexProject);
    setOpenAlert(false);
    setDisplaySpinner(true);
  };

  return (
      <PopUp
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        handleCancel={handleDontSave}
        handleConfirm={handleSave}
        title="Do you want to save the page ?"
        insideDescription="All changes will be lost if you change page"
        confirmText='Save'
        cancelText='Cancel'
      />
  );
};

export default ChangePagePopUpWindow;
